import React from "react";
import PropTypes from "prop-types";

import { ROLES } from "base/constants";

import { CommentReactionWrapper } from "./comment.reaction.wrapper";
import { CHANNEL_CONST } from "@/common/utils/constant";

import styles from "./post.css";

PostFooter.propTypes = {
  teamId: PropTypes.string,
  postData: PropTypes.object,
  roles: PropTypes.array,
  postNotification: PropTypes.object,
  focusedNotification: PropTypes.object,
  shouldCallDefaultComments: PropTypes.bool,
  updateBookmarkList: PropTypes.func
};
export function PostFooter({
  teamId,
  postData,
  postNotification,
  focusedNotification,
  shouldCallDefaultComments,
  roles,
  updateBookmarkList
}) {
  return (
    postData && (
      <div className={styles.postFooter}>
        <CommentReactionWrapper
          teamId={teamId}
          medium={postData.Medium}
          mediumId={postData.MediumId}
          isComment={postData.IsComment}
          instanceId={postData._id}
          instanceType={CHANNEL_CONST.POST}
          entityId={postData._id}
          entityType={CHANNEL_CONST.POST}
          creatorId={postData._created_by._id}
          roles={roles}
          seenCount={postData?.SeenCount}
          postNotification={postNotification}
          focusedNotification={focusedNotification}
          postMentions={
            postData.AtMention &&
            Object.values(postData.AtMention).filter(
              (mention) => mention.Kind === ROLES.USER
            )
          }
          shouldCallDefaultComments={shouldCallDefaultComments}
          isBookmarked={postData.IsBookmarked}
          updateBookmarkList={updateBookmarkList}
        />
      </div>
    )
  );
}
